module.exports = __webpack_public_path__ + "static/media/image18.3508276e.png";